import { Outlet, useNavigate, useParams } from "react-router-dom";
import useAppStore from "@/stores/useAppStore";
import { GetProjectById } from "@/apis/Project";
import { useEffect } from "react";
import useProjectStore from "@/stores/useProjectStore";

function ProjectRoute() {
  const setIsAppLoading = useAppStore((s) => s.setIsAppLoading);
  const setProject = useProjectStore((s) => s.setProject);
  const project = useProjectStore((s) => s.project);
  const { id } = useParams();
  const navigate = useNavigate();
  const resetProjectStore = useProjectStore((s) => s.resetProjectStore);
  useEffect(() => {
    if (!id) {
      navigate(-1);
    }
    return () => {
      resetProjectStore();
    };
  }, []);
  useEffect(() => {
    if (project) {
      return;
    }
    setIsAppLoading(true);
    GetProjectById(id as string).subscribe({
      next: (res) => {
        res.clearanceDistance = res.clearanceDistance || 3;
        setProject(res);
      },
      error: () => {
        setIsAppLoading(false);
        navigate("/");
      },
      complete: () => {
        setIsAppLoading(false);
      },
    });
  }, [project, id]);
  if (!project) {
    return null;
  }
  return (
    <div className="size-full">
      <Outlet />
    </div>
  );
}

export default ProjectRoute;
